import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { BottomSheetComponent } from '../consulta-geral/bottom-sheet/bottom-sheet.component';
import { ProjetoCadastro } from '../models/projeto-cadastro.model';
import { NavigationService } from '../services/navigation.service';
import { ProgramaService } from '../services/programa.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-programa-layout',
  templateUrl: './programa-layout.component.html',
  styleUrls: ['./programa-layout.component.scss']
})
export class ProgramaLayoutComponent extends BaseListComponent<ProjetoCadastro> implements OnInit, OnDestroy {

  serverUrl: string;
  idPrograma: number;
  programa: ProjetoCadastro;
  pathRoute: string;
  menu: any[];

  constructor(
    private router: Router,
    private storage: StorageService,
    private myService: ProgramaService,
    public activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    private navigation: NavigationService,
    private _bottomSheet: MatBottomSheet,
  ) {
    super()
  }

  ngOnInit(): void {
    this.serverUrl = environment.serverUrl;
    this.initLayout();
    this.addSub(EventSharedService.get('reloadLayout').subscribe((component) => {
      this.loading();
      this.addSub(
        this.myService.getById(this.idPrograma, true).subscribe(
          (res) => {
            this.programa = res;
            this.onActivate(component);
            this.loaded();
          },
          (error) => {
            this.loaded();
            this.msgError(error.error.message);
            this.navigation.replace(['projetos', 'programa']);
          },
        )
      );
    }));
  }

  initLayout() {
    this.loading();
    this.idPrograma = this.activatedRoute.snapshot.params?.idProjeto;
    this.programa = this.activatedRoute.snapshot.data.programa;
    this.initMenu();
    this.loaded();
  }


  initMenu(path = null) {
    this.pathRoute = path ? path : "/projetos/programa/" + this.idPrograma;
    this.menu = [
      {
        label: "Cadastro do Programa",
        rota: this.pathRoute + '/cadastro',
        active: true,
        type:'routerLink'
      },
      {
        label: "Projetos Agregadores",
        rota: this.pathRoute + "/agregadores",
        active: true,
        type:'routerLink'
      },
      {
        label: "Projetos",
        rota: this.pathRoute + "/projetos",
        active: true,
        type:'routerLink'
      },
      {
        label: "Indicadores",
        rota: this.pathRoute + "/indicadores",
        active: true,
        type:'routerLink'
      },
      {
        label: "Cronograma Gantt",
        rota: this.serverUrl + "/gantt/index3.php?pg_id=" + this.idPrograma,
        active: true,
        type:'href'
      }
    ]
  }

  isActive(route: string): boolean {
    return this.router.routerState.snapshot.url.includes(route)
  }

  ngOnDestroy(): void {
    this.storage.removeIdProjeto();
    this.unsubscribeList();
  }

  openBottomSheet(): void {
    this._bottomSheet.open(BottomSheetComponent, { data: { pathRoute: '', menu: this.menu } });
  }

  onActivate(component) {
    component.idPrograma = this.idPrograma;
    component.programa = this.programa;
  }
}
